module.exports = __webpack_public_path__ + "static/media/pic1.8f70a8ab.jpg";